/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum NotificationEventType {
  ProjectCreated = 'projectCreated',
  ProjectEdited = 'projectEdited',
  ProjectDeleted = 'projectDeleted',
  WorkPackageCreated = 'workPackageCreated',
  WorkPackageEdited = 'workPackageEdited',
  WorkPackageDeleted = 'workPackageDeleted',
  AttachmentCreated = 'attachmentCreated',
  AttachmentEdited = 'attachmentEdited',
  AttachmentDeleted = 'attachmentDeleted'
}
